@if ($model() != null && $flowDefinitionOrganizationId() != null) {
    <div class="{{$indentLevel() != null ? 'ml-' + $indentLevel() : ''}}">
        <!-- Patriarcas -->
        <div class="form-group forwarding-recipient ml-3px" featureHint="flowObjectDetails|EDocsLocationPatriarch" featureHintHAlign="right">
            <label for="patriarcaId">{{$patriarchLabel() || 'Selecione um Patriarca para filtrar os Órgãos abaixo'}}</label>

            <input type="text" class="form-control info-font one-button" id="patriarcaDisplay" name="patriarcaDisplay"
                   placeholder="(nenhum selecionado)"
                   [ngModel]="$patriarcaDisplay()"
                   [matTooltip]="$patriarcaNome()"
                   [matAutocomplete]="patriarcaAutocomplete"
                   [disabled]="$isReadOnlyMode()"
                   (ngModelChange)="$patriarcaDisplay.set($event)"
                   (input)="patriarcaDisplayChange()"
            >

            <mat-autocomplete #patriarcaAutocomplete="matAutocomplete"
                              [displayWith]="displayPatriarcaId"
                              (optionSelected)="patriarcaIdChange($event)"
            >
                @for (option of $selectablePatriarcas(); track option) {
                    <mat-option class="uppercase" [value]="option">{{option.sigla}} - {{option.nome}}</mat-option>
                }
            </mat-autocomplete>

            <i class="fas fa-times-circle action remove ml-2" matTooltip="Limpar" (click)="clearPatriarca()" (keyDown)="clearPatriarca()"></i>
        </div>

        <!-- Órgãos -->
        <div class="form-group forwarding-recipient ml-4" featureHint="flowObjectDetails|EDocsLocationOrganization" featureHintHAlign="right">
            <label for="organizacaoId">{{$organizationLabel() || 'Selecione um Órgão para filtrar as opções disponíveis abaixo'}}</label>

            <input type="text" class="form-control info-font" id="organizacaoDisplay" name="organizacaoDisplay"
                   placeholder="(nenhum selecionado)"
                   [ngClass]="$hideSelectOrganization() ? 'one-button' : 'two-buttons'"
                   [ngModel]="$organizacaoDisplay()"
                   [matTooltip]="$organizacaoNome()"
                   [matAutocomplete]="organizacaoAutocomplete"
                   [disabled]="isDisabledOrganizacao()"
                   (ngModelChange)="$organizacaoDisplay.set($event)"
                   (input)="organizacaoDisplayChange()"
            >

            <mat-autocomplete #organizacaoAutocomplete="matAutocomplete"
                              [displayWith]="displayOrganizacaoId"
                              (optionSelected)="organizacaoIdChange($event)"
            >
                @for (option of $selectableOrganizacoes(); track option) {
                    <mat-option [value]="option">
                        {{option.sigla}} - {{option.nomeFantasia == '.' ? option.sigla : option.nomeFantasia}}
                    </mat-option>
                }
            </mat-autocomplete>

            @if (!$hideSelectOrganization()) {
                <i class="fas fa-check-circle action add ml-2" matTooltip="Escolher" (click)="selectOrganizacao()" (keyDown)="selectOrganizacao()"></i>
            }
            <i class="fas fa-times-circle action remove ml-2" matTooltip="Limpar" (click)="clearOrganizacao()" (keyDown)="clearOrganizacao()"></i>
        </div>

        <!-- Setor -->
        @if (!$hideUnit()) {
            <div class="form-group forwarding-recipient ml-5" featureHint="flowObjectDetails|EDocsLocationUnit" featureHintHAlign="right">
                <label for="unidadeId">{{$unitLabel() || 'Setor'}}</label>

                <input type="text" class="form-control info-font two-buttons" id="unidadeDisplay" name="unidadeDisplay"
                       placeholder="(nenhum selecionado)"
                       [ngModel]="$unidadeDisplay()"
                       [matTooltip]="$unidadeNome()"
                       [matAutocomplete]="unidadeAutocomplete"
                       [disabled]="isDisabledUnidade()"
                       (ngModelChange)="$unidadeDisplay.set($event)"
                       (input)="unidadeDisplayChange()"
                >

                <mat-autocomplete #unidadeAutocomplete="matAutocomplete"
                                  [displayWith]="displayUnidadeId"
                                  (optionSelected)="unidadeIdChange($event)"
                >
                    @for (option of $selectableUnidades(); track option) {
                        <mat-option class="uppercase" [value]="option">{{option.nomeCurto ? option.nomeCurto + ' - ' : ''}}{{option.nome}}</mat-option>
                    }
                </mat-autocomplete>

                <i class="fas fa-check-circle action add ml-2" matTooltip="Escolher" (click)="selectUnidade()" (keyDown)="selectUnidade()"></i>
                <i class="fas fa-times-circle action remove ml-2" matTooltip="Limpar" (click)="clearUnidade()" (keyDown)="clearUnidade()"></i>
            </div>
        }

        <!-- Grupo de Trabalho -->
        @if (!$hideGroup()) {
            <div class="form-group forwarding-recipient ml-5" featureHint="flowObjectDetails|EDocsLocationGroup" featureHintHAlign="right">
                <label for="grupoId">{{$groupLabel() || 'Grupo de Trabalho'}}</label>

                <input type="text" class="form-control info-font two-buttons" id="grupoDisplay" name="grupoDisplay"
                       placeholder="(nenhum selecionado)"
                       [ngModel]="$grupoDisplay()"
                       [matTooltip]="$grupoNome()"
                       [matAutocomplete]="grupoAutocomplete"
                       [disabled]="isDisabledGrupo()"
                       (ngModelChange)="$grupoDisplay.set($event)"
                       (input)="grupoDisplayChange()"
                >

                <mat-autocomplete #grupoAutocomplete="matAutocomplete"
                                  [displayWith]="displayGrupoId"
                                  (optionSelected)="grupoIdChange($event)"
                >
                    @for (option of $selectableGrupos(); track option) {
                        <mat-option class="uppercase" [value]="option">{{option.nome}}</mat-option>
                    }
                </mat-autocomplete>

                <i class="fas fa-check-circle action add ml-2" matTooltip="Escolher" (click)="selectGrupo()" (keyDown)="selectGrupo()"></i>
                <i class="fas fa-times-circle action remove ml-2" matTooltip="Limpar" (click)="clearGrupo()" (keyDown)="clearGrupo()"></i>
            </div>
        }

        <!-- Comissão ou Contratos-->
        @if (!$hideComission()) {
            <div class="form-group forwarding-recipient ml-5" featureHint="flowObjectDetails|EDocsLocationComission" featureHintHAlign="right">
                <label for="comissaoId">{{$comissionLabel() || 'Comissão ou Contrato'}}</label>

                <input type="text" class="form-control info-font two-buttons" id="comissaoDisplay" name="comissaoDisplay"
                       placeholder="(nenhum selecionado)"
                       [ngModel]="$comissaoDisplay()"
                       [matTooltip]="$comissaoNome()"
                       [matAutocomplete]="comissaoAutocomplete"
                       [disabled]="isDisabledComissao()"
                       (ngModelChange)="$comissaoDisplay.set($event)"
                       (input)="comissaoDisplayChange()"
                >

                <mat-autocomplete #comissaoAutocomplete="matAutocomplete"
                                  [displayWith]="displayComissaoId"
                                  (optionSelected)="comissaoIdChange($event)"
                >
                    @for (option of $selectableComissoes(); track option) {
                        <mat-option class="uppercase" [value]="option">{{option.nome}}</mat-option>
                    }
                </mat-autocomplete>

                <i class="fas fa-check-circle action add ml-2" matTooltip="Escolher" (click)="selectComissao()" (keyDown)="selectComissao()"></i>
                <i class="fas fa-times-circle action remove ml-2" matTooltip="Limpar" (click)="clearComissao()" (keyDown)="clearComissao()"></i>
            </div>
        }
    </div>
}
